function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}export var LayoutService = /*#__PURE__*/function () {LayoutService.$inject = ["$state"];
  function LayoutService($state) {
    "ngInject";_classCallCheck(this, LayoutService);
    this.$state = $state;
    this._isSidebarRightVisible = true;
    this._isNewDashboard = false;
  }_createClass(LayoutService, [{ key: "isSidebarRightVisible", get: function get()

    {
      return this._isSidebarRightVisible && !(
      this.$state.current.data &&
      typeof this.$state.current.data.isSidebarRightVisible !== 'undefined' &&
      !this.$state.current.data.isSidebarRightVisible);

    }, set: function set(

    val) {
      this._isSidebarRightVisible = val;
    } }, { key: "isNewDashboard", get: function get()


    {
      return this._isNewDashboard && !(
      this.$state.current.data &&
      typeof this.$state.current.data.isNewDashboard !== 'undefined' &&
      !this.$state.current.data.isNewDashboard);

    } }]);return LayoutService;}();